/**
 * I didn't want to include a 116kb of `uuid` npm package
 * just for the sole purpose of generating unique ids.
 */
import crypto from 'crypto'

export const generateRandomId = (): string =>
  crypto.randomBytes(16).toString('hex')
